export default "__VITE_ASSET__DuF589dU__"